if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      const quickAddModal = this.closest('quick-add-modal');
      const quickAddOpener = quickAddModal && quickAddModal.openedBy;
      const previousQuickAddError = quickAddOpener && quickAddOpener.parentElement && quickAddOpener.parentElement.nextElementSibling;
      if (previousQuickAddError && previousQuickAddError.hasAttribute('data-quick-add-uncertainty')) {
        previousQuickAddError.remove();
      }

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => {
                try {
                  this.cart.renderContents(response);
                } catch (error) {
                  this.handleAddUncertainty(error, quickAddModal, quickAddOpener);
                }
              });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((error) => this.handleAddUncertainty(error, quickAddModal, quickAddOpener))
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleAddUncertainty(error, quickAddModal, opener) {
      console.error(error);
      const message = '追加結果を確認できません。カートを確認してから、必要な場合のみ再操作してください。';
      if (quickAddModal && !this.isConnected) {
        const currentForm = quickAddModal.hasAttribute('open') && quickAddModal.querySelector('product-form');
        if (currentForm && currentForm.isConnected) {
          currentForm.handleErrorMessage(message);
          return;
        }
        this.handleErrorMessage(message);
        this.moveQuickAddError(opener);
        return;
      }
      this.handleErrorMessage(message);
    }

    moveQuickAddError(opener) {
      const errorWrapper = this.errorMessageWrapper;
      if (opener && opener.isConnected && opener.parentElement && errorWrapper) {
        errorWrapper.setAttribute('data-quick-add-uncertainty', '');
        opener.parentElement.insertAdjacentElement('afterend', errorWrapper);
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper && errorMessage) {
        this.errorMessageWrapper = document.createElement('div');
        this.errorMessageWrapper.classList.add('product-form__error-message-wrapper');
        this.errorMessageWrapper.setAttribute('role', 'alert');
        this.errorMessage = document.createElement('span');
        this.errorMessage.classList.add('product-form__error-message');
        this.errorMessageWrapper.appendChild(this.errorMessage);
        this.insertBefore(this.errorMessageWrapper, this.form);
      }
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
